package com.shadowings.gero.data.lessons.chapter5

import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_participi_alyn_1
import gero.composeapp.generated.resources.exp_content_participi_alyn_10
import gero.composeapp.generated.resources.exp_content_participi_alyn_11
import gero.composeapp.generated.resources.exp_content_participi_alyn_12
import gero.composeapp.generated.resources.exp_content_participi_alyn_13
import gero.composeapp.generated.resources.exp_content_participi_alyn_2
import gero.composeapp.generated.resources.exp_content_participi_alyn_3
import gero.composeapp.generated.resources.exp_content_participi_alyn_4
import gero.composeapp.generated.resources.exp_content_participi_alyn_5
import gero.composeapp.generated.resources.exp_content_participi_alyn_6
import gero.composeapp.generated.resources.exp_content_participi_alyn_7
import gero.composeapp.generated.resources.exp_content_participi_alyn_8
import gero.composeapp.generated.resources.exp_content_participi_alyn_9
import gero.composeapp.generated.resources.exp_content_participi_nilo_1
import gero.composeapp.generated.resources.exp_title_participi_intro
import gero.composeapp.generated.resources.quiz_participi_1_1
import gero.composeapp.generated.resources.quiz_participi_1_2
import gero.composeapp.generated.resources.quiz_participi_1_3
import gero.composeapp.generated.resources.quiz_participi_1_4
import gero.composeapp.generated.resources.quiz_participi_1_5
import gero.composeapp.generated.resources.quiz_participi_1_6
import gero.composeapp.generated.resources.quiz_participi_1_7
import gero.composeapp.generated.resources.quiz_participi_1_8

fun getParticipiIntroContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_nilo_1,
            face = Faces.Sleeping,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_1,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_2,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_3,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_4,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_5,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_6,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_7,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_8,
            face = Faces.Perfect,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_9,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_10,
            face = Faces.Serious,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_11,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_12,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = { MdCWord("F35-R4:X1*Q3", rtl = false, cart = true, size = 96.dp) }
        ),
        ExplanationContent(
            title = Res.string.exp_title_participi_intro,
            content = Res.string.exp_content_participi_alyn_13,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
    )
}

fun getParticipiIntroQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_participi_1_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_2,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_3,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_4,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_5,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_6,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_7,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_participi_1_8,
            correct = false
        )
    )
}
